<template>
    <div class="home relative">
        <a href="https://wa.me/6596317637" target="_blank" class="btn-wa">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="48" height="48"><path fill="none" d="M0 0h24v24H0z"/><path d="M2.004 22l1.352-4.968A9.954 9.954 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10a9.954 9.954 0 0 1-5.03-1.355L2.004 22zM8.391 7.308a.961.961 0 0 0-.371.1 1.293 1.293 0 0 0-.294.228c-.12.113-.188.211-.261.306A2.729 2.729 0 0 0 6.9 9.62c.002.49.13.967.33 1.413.409.902 1.082 1.857 1.971 2.742.214.213.423.427.648.626a9.448 9.448 0 0 0 3.84 2.046l.569.087c.185.01.37-.004.556-.013a1.99 1.99 0 0 0 .833-.231c.166-.088.244-.132.383-.22 0 0 .043-.028.125-.09.135-.1.218-.171.33-.288.083-.086.155-.187.21-.302.078-.163.156-.474.188-.733.024-.198.017-.306.014-.373-.004-.107-.093-.218-.19-.265l-.582-.261s-.87-.379-1.401-.621a.498.498 0 0 0-.177-.041.482.482 0 0 0-.378.127v-.002c-.005 0-.072.057-.795.933a.35.35 0 0 1-.368.13 1.416 1.416 0 0 1-.191-.066c-.124-.052-.167-.072-.252-.109l-.005-.002a6.01 6.01 0 0 1-1.57-1c-.126-.11-.243-.23-.363-.346a6.296 6.296 0 0 1-1.02-1.268l-.059-.095a.923.923 0 0 1-.102-.205c-.038-.147.061-.265.061-.265s.243-.266.356-.41a4.38 4.38 0 0 0 .263-.373c.118-.19.155-.385.093-.536-.28-.684-.57-1.365-.868-2.041-.059-.134-.234-.23-.393-.249-.054-.006-.108-.012-.162-.016a3.385 3.385 0 0 0-.403.004z" fill="rgba(35,205,100,1)"/></svg>
        </a>
        <SiteHeader />
        <SiteBanner />
        <SiteSymptoms />
        <SiteAbout />
        <SiteMisconceptions />
        <SiteWhy />
        <SiteAbout2 />
        <SiteInsurance />
        <SiteFaq />
        <SiteEnquire />
        <SiteFooter />
    </div>
</template>

<style scoped>
  .btn-wa {
    background-color: white;
    border-radius: 100%;
    position: fixed;
    bottom: 15px;
    right: 15px;
    z-index: 100;
  }
</style>

<script>
    // @ is an alias to /src
    import SiteHeader from '@/components/SiteHeader.vue'
    import SiteBanner from '@/components/SiteBanner.vue'
    import SiteAbout from '@/components/SiteAbout.vue'
    import SiteSymptoms from '@/components/SiteSymptoms.vue'
    import SiteAbout2 from '@/components/SiteAbout2.vue'
    import SiteMisconceptions from '@/components/SiteMisconceptions.vue'
    import SiteWhy from '@/components/SiteWhy.vue'
    import SiteInsurance from '@/components/SiteInsurance.vue'
    import SiteFaq from '@/components/SiteFaq.vue'
    import SiteEnquire from '@/components/SiteEnquire.vue'
    import SiteFooter from '@/components/SiteFooter.vue'

    export default {
        name: 'Home',
        components: {
            SiteHeader,
            SiteBanner,
            SiteAbout,
            SiteSymptoms,
            SiteAbout2,
            SiteMisconceptions,
            SiteWhy,
            SiteInsurance,
            SiteFaq,
            SiteEnquire,
            SiteFooter,
        }
    }
</script>